
        require('./index.scss');
        'use strict';

var _commonFloatIm = require('module/common/common-float-im');

var _commonFloatIm2 = _interopRequireDefault(_commonFloatIm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ = window.$;
var $mod = $('.module-news-list');


var _module = {
    init: function init() {
        $(window.document).ready(function () {
            _commonFloatIm2['default'].init({
                pid: $mod.data('proj_id'), //楼盘ID
                pname: $mod.data('proj_name'), //楼盘名称
                cityId: $mod.data('city_id')
            });
            var $newsItems = $mod.find('[node-type~="news-item-content-limited"]');
            var newsItemHeightLimit = parseInt($newsItems.attr('data-height'), 10);
            $newsItems.each(function (i, el) {
                var $this = $(el);
                var textNode = el.childNodes[0];
                if ($this.height() > newsItemHeightLimit) {
                    textNode.nodeValue += '...';
                }
                while ($this.height() > newsItemHeightLimit) {
                    var s = textNode.nodeValue;
                    textNode.nodeValue = s.substr(0, s.length - 4) + '...';
                }
            });
        });
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/loupan-evaluate-new/evaluate-list/index.js